/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AiTutorFormativeFeedbackFocusQualityAssessment } from './aiTutorFormativeFeedbackFocusQualityAssessment';
import type { AiTutorFormativeFeedbackRoutingDecision } from './aiTutorFormativeFeedbackRoutingDecision';

/**
 * Student-facing formative feedback for the AI Tutor MVP.
 */
export interface AiTutorFormativeFeedback {
  /** The section or dimension the student most recently worked on (copied from stage recognition). */
  detectedCurrentFocus: string;
  /** Whether the student's current focus appears acceptable or still weak. */
  focusQualityAssessment: AiTutorFormativeFeedbackFocusQualityAssessment;
  /** Whether the tutor should stay on the current focus or redirect. */
  routingDecision: AiTutorFormativeFeedbackRoutingDecision;
  /** The dimension the hint should focus on. */
  targetDimension: string;
  /** Neutral observation or short validation of what the student has currently done or focused on. */
  observation: string;
  /** Single next step that guides the student without exposing rubric details. */
  nextStep: string;
  /** Whether the hidden evaluation indicates the student is already ready to progress. */
  isReadyToProgress: boolean;
}
